"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/label-has-associated-control */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const routes_1 = require("~/consts/routes");
const passwordPolicy_1 = require("~/consts/passwordPolicy");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const Button_1 = require("~/components/UI/Button");
const Input_1 = require("~/components/UI/Input");
const assets_1 = require("~/assets");
const useActionToken_1 = __importDefault(require("~/hooks/useActionToken"));
const consts_1 = require("~/store/account/consts");
const react_helmet_async_1 = require("react-helmet-async");
const useSubmissionGuard_1 = __importDefault(require("~/hooks/useSubmissionGuard"));
const AuthorizationForm_module_scss_1 = __importDefault(require("../AuthorizationForm.module.scss"));
function SignUp() {
    var _a, _b, _c;
    const { t } = (0, react_i18next_1.useTranslation)('authorization');
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const [, isTokenValid, decoded, userData] = (0, useActionToken_1.default)((_a = searchParams.get('token')) !== null && _a !== void 0 ? _a : '');
    const [subtitle, setSubtitle] = (0, react_1.useState)(null);
    const [errorState, setErrorState] = (0, react_1.useState)(false);
    const [loginInitiated, setLoginInit] = (0, react_1.useState)(false);
    const [userType, setUserType] = (0, react_1.useState)(null);
    const [signUpMode, setSignUpMode] = (0, react_1.useState)('standard');
    const [email, setEmail] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [password, setPassword] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [firstName, setFirstName] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [lastName, setLastName] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [companyName, setCompanyName] = (0, react_1.useState)('');
    const [invitedBy, setInvitedBy] = (0, react_1.useState)();
    const emailRef = react_1.default.createRef();
    const signupFailed = (_b = (0, react_redux_1.useSelector)(selectors_1.selectSignupFailed)) !== null && _b !== void 0 ? _b : false;
    const invitedTeamMember = 'invited-team-member';
    const { isSubmitting, trySubmit } = (0, useSubmissionGuard_1.default)();
    const { dispatchSignup } = (0, redux_1.bindActionCreators)({
        dispatchSignup: actions_1.signup,
    }, (0, react_redux_1.useDispatch)());
    const signUpUser = (event) => {
        event.preventDefault();
        const signUpData = {
            email: email.value,
            password: password.value,
            lastName: lastName.value,
            firstName: firstName.value,
            companyName,
            invitedBy,
        };
        trySubmit(() => {
            dispatchSignup(signUpData);
            setLoginInit(true);
            setErrorState(false);
        });
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (loginInitiated && signupFailed) {
            setErrorState(signupFailed);
            (_a = emailRef.current) === null || _a === void 0 ? void 0 : _a.highlight();
        }
    }, [signupFailed, loginInitiated, emailRef]);
    (0, react_1.useEffect)(() => {
        setErrorState(false);
    }, []);
    (0, react_1.useEffect)(() => {
        if (decoded && isTokenValid) {
            setSignUpMode(decoded.type);
            switch (decoded.type) {
                case 'invite-customer':
                    setSubtitle(t('headline.sign-up.invited-customer', { distributorCompany: decoded.distributorCompanyName }));
                    break;
                case invitedTeamMember:
                    setSubtitle(t('headline.sign-up.invited-team-member', { companyName: decoded.companyName }));
                    break;
                default:
                    break;
            }
            setCompanyName(decoded.companyName);
            setFirstName({ value: decoded.firstName, error: null });
            setLastName({ value: decoded.lastName, error: null });
            setEmail(Object.assign(Object.assign({}, email), { value: decoded.email }));
            setInvitedBy(decoded.invitedBy);
        }
    }, [decoded]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (userData === null || userData === void 0 ? void 0 : userData.user) {
            setFirstName({ value: (_a = userData === null || userData === void 0 ? void 0 : userData.user) === null || _a === void 0 ? void 0 : _a.firstName, error: null });
            setLastName({ value: (_b = userData === null || userData === void 0 ? void 0 : userData.user) === null || _b === void 0 ? void 0 : _b.lastName, error: null });
            setEmail(Object.assign(Object.assign({}, email), { value: decoded === null || decoded === void 0 ? void 0 : decoded.email }));
            setUserType((_d = (_c = userData === null || userData === void 0 ? void 0 : userData.user) === null || _c === void 0 ? void 0 : _c.userType) === null || _d === void 0 ? void 0 : _d.name);
            if (((_f = (_e = userData === null || userData === void 0 ? void 0 : userData.user) === null || _e === void 0 ? void 0 : _e.userType) === null || _f === void 0 ? void 0 : _f.name) === consts_1.UserRoles.distributor && signUpMode !== invitedTeamMember) {
                setCompanyName((_g = userData === null || userData === void 0 ? void 0 : userData.user) === null || _g === void 0 ? void 0 : _g.companyName);
                setSubtitle(t('headline.sign-up.subtitleDistributor', { distributorCompany: (_h = userData === null || userData === void 0 ? void 0 : userData.user) === null || _h === void 0 ? void 0 : _h.companyName }));
            }
            if (((_k = (_j = userData === null || userData === void 0 ? void 0 : userData.user) === null || _j === void 0 ? void 0 : _j.userType) === null || _k === void 0 ? void 0 : _k.name) === consts_1.UserRoles.admin) {
                setCompanyName('TSLOTS by Bonnell Aluminum');
            }
            if (((_m = (_l = userData === null || userData === void 0 ? void 0 : userData.user) === null || _l === void 0 ? void 0 : _l.userType) === null || _m === void 0 ? void 0 : _m.name) === consts_1.UserRoles.customer) {
                if (((_o = userData === null || userData === void 0 ? void 0 : userData.user) === null || _o === void 0 ? void 0 : _o.companyName) !== '-') {
                    setCompanyName((_p = userData === null || userData === void 0 ? void 0 : userData.user) === null || _p === void 0 ? void 0 : _p.companyName);
                }
            }
        }
    }, [userData === null || userData === void 0 ? void 0 : userData.user]);
    return (react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.container },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, "Sign Up | TBUILD")),
        react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.headline },
            t('headline.sign-up.main'),
            react_1.default.createElement("div", null, subtitle !== null && subtitle !== void 0 ? subtitle : (userType === consts_1.UserRoles.distributor
                ? t('headline.sign-up.subtitleDistributor', { distributorCompany: (_c = userData === null || userData === void 0 ? void 0 : userData.user) === null || _c === void 0 ? void 0 : _c.companyName })
                : t('headline.sign-up.subtitle'))),
            errorState ? react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.error }, t('headline.sign-up.error')) : null),
        react_1.default.createElement("form", null,
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.info },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("label", null, t('firstName.title')),
                    react_1.default.createElement(Input_1.Input, { type: "text", placeholder: t('firstName.placeholder'), value: firstName.value, onChange: (value, error) => setFirstName({ value, error }), onInput: (value, error) => setFirstName({ value, error }), maxLength: 60, required: true })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("label", null, t('lastName.title')),
                    react_1.default.createElement(Input_1.Input, { type: "text", placeholder: t('lastName.placeholder'), maxLength: 60, required: true, value: lastName.value, onChange: (value, error) => setLastName({ value, error }), onInput: (value, error) => setLastName({ value, error }) }))),
            react_1.default.createElement("label", null, t('company.title')),
            react_1.default.createElement(Input_1.Input, { type: "text", placeholder: t('company.placeholder'), maxLength: 255, value: companyName, onChange: setCompanyName, disabled: signUpMode === invitedTeamMember || userType === 'distributor' || userType === 'admin' }),
            react_1.default.createElement("label", null, t('email.title')),
            react_1.default.createElement(Input_1.Input, { type: "email", placeholder: t('email.placeholder'), value: email.value ? email.value : '', onChange: (value, error) => setEmail({ value, error }), onInput: (value, error) => setEmail({ value: email.value, error }), maxLength: 255, required: true, customErrors: { required: t('email.error.required') }, ref: emailRef, disabled: signUpMode === 'invite-customer' || signUpMode === invitedTeamMember || !!userData, name: "xyz123", id: "xyz123", autoComplete: "xyz123" }),
            react_1.default.createElement("label", null, t('password.title')),
            react_1.default.createElement(Input_1.Input, { type: "password", placeholder: t('password.placeholder'), minLength: passwordPolicy_1.PASSWORD_MIN_LENGTH, maxLength: passwordPolicy_1.PASSWORD_MAX_LENGTH, value: password.value ? password.value : '', onInput: (value, error) => setPassword({ value, error }), customErrors: { 'required': t('password.error.required'), 'min-value': t('password.error.min-value'), 'max-value': t('password.error.max-value') }, required: true, name: "xyz123p", id: "xyz123p", autoComplete: "xyz123p" }),
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.submitButton },
                react_1.default.createElement(Button_1.Button, { wide: true, variant: "primary", onClick: signUpUser, disabled: isSubmitting ||
                        Boolean(email.error || password.error || firstName.error || lastName.error) ||
                        Boolean(email.value.trim() === '' ||
                            password.value.trim().length < passwordPolicy_1.PASSWORD_MIN_LENGTH ||
                            password.value.trim().length > passwordPolicy_1.PASSWORD_MAX_LENGTH ||
                            firstName.value.trim() === '' ||
                            lastName.value.trim() === '') }, t('button.sign-up')))),
        react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.footer },
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.bottomlink, role: "button", tabIndex: 0 },
                react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.ROUTE_LOGIN },
                    react_1.default.createElement("img", { src: assets_1.svgSystemChevronLeft, alt: "" }),
                    t('button.back-to-sign-in'))))));
}
exports.default = SignUp;
